import { multicastChannel, MulticastChannel } from 'redux-saga';
import { all, call, delay, fork, put, take, takeLatest } from 'typed-redux-saga';

import { setDebugMenuStatsReport } from '../../../../../shared/features/room-agent/dtmf/debug-menu/actions';
import { ChannelHolder } from '../../../../../shared/helpers/channelHolder';
import {
    DrawingPerformanceStats,
    DrawingPerformanceStatsReport,
} from '../../../../../shared/helpers/drawing-performance-stats';
import { SignalingAPI } from '../api/SignalingAPI';

function* debugMenuStatsSaga(drawingPerformanceStatsChannel: MulticastChannel<DrawingPerformanceStatsReport>) {
    while (true) {
        const { drawingPerformanceStats } = yield* all({
            drawingPerformanceStats: take(drawingPerformanceStatsChannel, '*'),
            throttle: delay(5000),
        });

        yield* put(setDebugMenuStatsReport({ drawingPerformance: drawingPerformanceStats }));
    }
}

function* signalingStatsSaga(
    drawingPerformanceStatsChannel: MulticastChannel<DrawingPerformanceStatsReport>,
    signaling: SignalingAPI
) {
    while (true) {
        const { drawingPerformanceStats } = yield* all({
            drawingPerformanceStats: take(drawingPerformanceStatsChannel, '*'),
            throttle: delay(10000),
        });

        yield* call([signaling, signaling.onStats], drawingPerformanceStats);
    }
}

export function* statsSaga({ signaling, channelHolder }: { signaling: SignalingAPI; channelHolder: ChannelHolder }) {
    const drawingPerformanceStatsCollector = new DrawingPerformanceStats({ interval: 5000 });
    const drawingPerformanceStatsChannel = multicastChannel<DrawingPerformanceStatsReport>();

    yield* fork(debugMenuStatsSaga, drawingPerformanceStatsChannel);
    yield* fork(signalingStatsSaga, drawingPerformanceStatsChannel, signaling);

    yield* takeLatest(
        channelHolder.getChannelForEmmiter<DrawingPerformanceStatsReport>(
            drawingPerformanceStatsCollector,
            'performance-stats'
        ),
        function* (report: [DrawingPerformanceStatsReport]) {
            yield* put(drawingPerformanceStatsChannel, report[0]);
        }
    );
}
